<template>
  <div class="login-page">
    <ElementBrand />
    <TheLogin>
      <TheLoginPanel v-if="!passwordForget" />
      <TheLoginPassword v-else />
    </TheLogin>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ElementBrand from '@elements/ElementBrand'
import TheLogin from '@blocks/login/TheLogin'
import TheLoginPanel from '@blocks/login/TheLoginPanel'
import TheLoginPassword from '@blocks/login/TheLoginPassword'

export default {
  name: 'LoginView',
  components: {
    ElementBrand,
    TheLogin,
    TheLoginPanel,
    TheLoginPassword
  },

  computed: {
    ...mapGetters({
      passwordForget: 'auth/getForgetPassword'
    })
  }
}
</script>

<style lang="scss">
.login-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6.5rem;
  background-color: colors("foreground");
  height: 100vh;

  .brand{
    margin-bottom: 4rem;
  }

  .login{
      @include media("small-medium"){
        width: 90%;
      }
      @include media("large"){
        width: 44rem;
      }
      min-height: 32.3rem;
  }

}

</style>
